angular.module('LessonControllers')

  .filter('toPercent', ['lesson', function(lesson) {
    return function(score) {
      return lesson.getPercentage(score);
    };
  }])

  .filter('toDisplay', ['EXAM', '$sce', function(EXAM, $sce) {
    return function(content) {
      if (content) {
        if (EXAM === 'lerobert' || EXAM === 'delf') {
          return content;
        }
        return content.replace( new RegExp(/img +src=[\'|\"](.*)[\'|\"]/g),'img src="media/$1"');
      }
    };
  }]);
